<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import ChatMessage from '../components/ChatMessage.vue'
import { getExport, type ExportSnapshot } from '../services/export'
const route=useRoute(),snapshot=ref<ExportSnapshot|null>(null),error=ref('')
onMounted(async()=>{try{snapshot.value=await getExport(String(route.params.conversationId));document.title=snapshot.value.title}catch(e){error.value=e instanceof Error?e.message:'读取失败'}})
function print(){window.print()}
</script>
<template><main class="print-view"><div class="print-toolbar"><button :disabled="!snapshot" @click="print">打印 / 保存 PDF</button><p>在打印窗口选择“另存为 PDF”。</p></div>
  <p v-if="error" role="alert">{{error}}</p><p v-if="!snapshot&&!error">正在读取完整对话…</p>
  <template v-if="snapshot"><h1>{{snapshot.title}}</h1><p>导出时间：{{new Date(snapshot.exported_at).toLocaleString()}}</p>
    <p>此文件仅包含导出时已保存的记录。<span v-if="snapshot.generation_active">当前仍有回答生成中。</span></p>
    <section v-for="(message,index) in snapshot.messages" :key="index"><p class="print-round">问题 {{message.turn}}<span v-if="message.public_label"> · 第 {{message.ab_round||1}} 轮</span></p>
      <ChatMessage :message="message" :feedback-disabled="true" />
      <p v-if="message.public_label&&snapshot.messages.filter(x=>x.turn===message.turn&&x.ab_round===message.ab_round&&x.public_label&&x.status==='complete').length<2">本轮双回答未完整保存。</p>
    </section>
  </template>
</main></template>
